import React from 'react';
import block from 'bem-cn-lite';
import {Helmet} from 'react-helmet';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

import img404src from '@yandex-data-ui/cloud-components/assets/images/illustration/light/404.svg';
import img500src from '@yandex-data-ui/cloud-components/assets/images/illustration/light/500.svg';

import './ErrorPage.scss';

const b = block('ErrorPage');

interface ErrorPageProps extends WithTranslationProps {
    code?: number;
}

class ErrorPage extends React.Component<ErrorPageProps> {
    static defaultProps = {
        code: 500,
    };

    render() {
        const {code} = this.props;

        return (
            <div className={b({code})}>
                {this.renderMeta()}
                {this.renderImage()}
                {this.renderCodeTitle()}
                {this.renderTitle()}
                {this.renderDescription()}
            </div>
        );
    }

    private renderMeta() {
        const {i18nK} = this.props;

        return <Helmet title={i18nK(`label_meta-title-${this.publicCode}`)} />;
    }

    private renderImage() {
        const {code} = this.props;
        const imgSrc = code === 404 ? img404src : img500src;

        return (
            <img
                src={imgSrc as unknown as string}
                alt=""
                width="220"
                height="220"
                className={b('image')}
            />
        );
    }

    private renderCodeTitle() {
        const {i18nK} = this.props;

        return <h1 className={b('code')}>{i18nK('label_title-code', {code: this.publicCode})}</h1>;
    }

    private renderTitle() {
        const {i18nK} = this.props;

        return <h2 className={b('title')}>{i18nK(`label_title-${this.publicCode}`)}</h2>;
    }

    private renderDescription() {
        const {i18nK} = this.props;

        return (
            <p className={b('description')}>
                {this.publicCode === 404 ? (
                    <a href="/">{i18nK('label_link-main')}</a>
                ) : (
                    <React.Fragment>
                        {i18nK('label_description-1')}
                        <a onClick={() => window.location.reload()}>
                            {i18nK('label_description-link')}
                        </a>
                        {i18nK('label_description-2')}
                    </React.Fragment>
                )}
            </p>
        );
    }

    private get publicCode() {
        return this.props.code === 404 ? 404 : 500;
    }
}

export default withTranslation('error')(ErrorPage);
